import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import CaseStudiesComponents from "./CaseStudiesComponents/CaseStudiesComponents";
import { caseStudies } from "../../data/caseStudies";
import "./CaseStudies.css";

const CaseStudies = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.slice(1);
    const scrollToTarget = () => {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    scrollToTarget();
    const timeoutId = window.setTimeout(scrollToTarget, 100);

    return () => window.clearTimeout(timeoutId);
  }, [location.hash]);

  return (
    <div className="CaseStudies">
      <Navbar />
      <div className="case-studies-hero">
        <div className="container">
          <h1>Case Studies</h1>
          <p>
            Structured proof from real products and client work — what the challenge was,
            what Belsoft built, and what went live.
          </p>
        </div>
      </div>
      <div className="case-studies-list">
        {caseStudies.map((study, index) => (
          <CaseStudiesComponents
            key={study.id}
            study={study}
            imageOnRight={index % 2 === 0}
          />
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default CaseStudies;
